import path from 'ramda/src/path'

import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId }) => {
	const buttons = path(
		[moduleId, 'buttons'], moduleDescriptions,
	)

	if (typeof buttons === 'function') {
		return buttons(state)
	}

	return buttons
}
